<div *ngIf="!campaignParticipantMission?.id" style="padding-top: 25px;">
    <app-button [busy]="busy" [disabled]="busy" (click)="createCampaignParticipantMission()">Start a mission for "{{campaign?.label}}"!</app-button>
</div>

<form
    class="campaign-participant-profile-edit-container"
    #missionForm="bkForm"
    (bkSubmit)="save(missionForm)"
    bkForm
    *ngIf="campaignParticipantMission?.id && campaignParticipantMission.mission?.id"
>

    <div class="section-title margin-top padding-top padding-bottom padding-left-right">
        <span>Mission</span>
    </div>

    <div class="margin-top padding-top padding-bottom padding-left-right campaign-participant-profile-edit-url">
        <div class="input-holder">
            <div class="input-label-above">URL</div>
            <div class="input">
                <a class="url" target="_blank" [href]="campaignParticipantMissionUrl()">{{campaignParticipantMissionUrl()}}</a>
            </div>
        </div>
    </div>

    <div class="margin-top padding-top padding-bottom padding-left-right campaign-participant-profile-edit-event-type">
        <div class="input-holder" bkFormControlHolder>
            <div class="input-label-above">Type of event</div>
            <input
                bkFormControl
                name="CampaignParticipantEventType"
                type="text"
                [(ngModel)]="campaignParticipantMission.mission.data.eventType"
                required
                [disabled]="saving"
            />
            <bk-validation-display></bk-validation-display>
            <div class="misc-customerinfo selected-org-description">
                <span>Walk, run, swim, bike, "Sober October", etc. It's up to you!</span>
            </div>
        </div>
    </div>

    <div class="campaign-participant-profile-edit-event-location margin-top padding-top padding-bottom">
        <div class="title padding-left-right">
            <span>Event location</span>
        </div>
        <div class="campaign-participant-profile-edit-line padding-top-none threefer">
            <div class="input-holder" bkFormControlHolder>
                <div class="input-label" *ngIf="!campaignParticipantMission.mission.data.eventLocationCity">City</div>
                <input
                    bkFormControl
                    name="CampaignParticipantEventLocationCity"
                    type="text"
                    [(ngModel)]="campaignParticipantMission.mission.data.eventLocationCity"
                    autocomplete="home city"
                    required
                    [disabled]="saving"
                />
                <bk-validation-display></bk-validation-display>
            </div>
            <div class="input-holder" bkFormControlHolder>
                <div class="input-label" *ngIf="!campaignParticipantMission.mission.data.eventLocationState">Province / State</div>
                <input
                    bkFormControl
                    name="CampaignParticipantEventLocationState"
                    type="text"
                    [(ngModel)]="campaignParticipantMission.mission.data.eventLocationState"
                    autocomplete="home state"
                    required
                    [disabled]="saving"
                />
                <bk-validation-display></bk-validation-display>
            </div>
            <div class="input-holder" bkFormControlHolder>
                <div class="input-label" *ngIf="!campaignParticipantMission.mission.data.eventLocationCountry">Country</div>
                <bk-select-countries
                    bkFormControl
                    name="CampaignParticipantEventLocationCountry"
                    [(ngModel)]="campaignParticipantMission.mission.data.eventLocationCountry"
                    [selectList]="env.countries"
                    autocomplete="country"
                    required
                    [disabled]="saving"
                ></bk-select-countries>
                <bk-validation-display></bk-validation-display>
            </div>
        </div>
    </div>

    <div class="margin-top padding-top padding-bottom padding-left-right campaign-participant-profile-edit-event-type">
        <div class="input-holder" bkFormControlHolder>
            <div class="input-label-above">When is it happening?</div>
            <input
                bkFormControl
                name="CampaignParticipantEventWhen"
                type="text"
                [(ngModel)]="campaignParticipantMission.mission.data.when"
                required
                [disabled]="saving"
            />
            <bk-validation-display></bk-validation-display>
            <div class="misc-customerinfo selected-org-description">
                <span>This is freeform - it can be a specific date or a span of time.</span>
            </div>
        </div>
    </div>

    <div class="margin-top padding-top padding-bottom padding-left-right campaign-participant-profile-edit-why">
        <div class="input-holder" bkFormControlHolder>
            <div class="input-label-above">Why are you doing this?</div>
            <textarea
                bkFormControl
                [name]="'CampaignParticipantWhy'"
                [(ngModel)]="campaignParticipantMission.mission.data.why"
                rows="5"
                required
                [disabled]="saving"
            ></textarea>
            <bk-validation-display></bk-validation-display>
        </div>
    </div>

    <div class="margin-top padding-top padding-bottom padding-left-right campaign-participant-profile-edit-who">
        <div class="input-holder" bkFormControlHolder>
            <div class="input-label-above">Who are you doing this for?</div>
            <textarea
                bkFormControl
                [name]="'CampaignParticipantWho'"
                [(ngModel)]="campaignParticipantMission.mission.data.who"
                rows="5"
                required
                [disabled]="saving"
            ></textarea>
            <bk-validation-display></bk-validation-display>
        </div>
    </div>

    <div class="margin-top padding-top padding-bottom padding-left-right campaign-participant-profile-edit-video-embed-url">
        <div class="input-holder" bkFormControlHolder>
            <div class="input-label-above">YouTube Video Embed URL (Optional)</div>
            <input
                bkFormControl
                name="CampaignParticipantLandingVideoEmbedUrl"
                type="text"
                [(ngModel)]="campaignParticipantMission.mission.data.landingVideoEmbedUrl"
                [disabled]="saving"
            />
            <bk-validation-display></bk-validation-display>
            <div class="misc-customerinfo selected-org-description">
                <span>A video for your campaign landing page. <b>Format: https://www.youtube.com/embed/iUvCXG9DTUI</b></span>
            </div>
        </div>
    </div>

    <div class="margin-top padding-top padding-bottom padding-left-right campaign-participant-profile-edit-event-type">
        <div class="input-holder" bkFormControlHolder>
            <div class="input-label-above">Fundraising Goal</div>
            <input
                bkFormControl
                name="campaignParticipantMissionFundraisingGoal"
                type="number"
                [(ngModel)]="campaignParticipantMission.mission.data.fundraisingGoal"
                [disabled]="saving"
            />
            <bk-validation-display></bk-validation-display>
            <div class="misc-customerinfo selected-org-description">
                <span>Do you have a fundraising goal for this event? If so please let us know how much you'd like to raise.</span>
            </div>
        </div>
    </div>

    <div class="margin-top padding-top padding-bottom padding-left-right campaign-participant-profile-edit-social-quote">
        <div class="input-holder" bkFormControlHolder>
            <div class="input-label-above">Social-app preview text (Optional)</div>
            <textarea
                bkFormControl
                [name]="'CampaignParticipantMetaOgDescription'"
                [(ngModel)]="campaignParticipantMission.mission.data.ogDescription"
                rows="5"
                [disabled]="saving"
            ></textarea>
            <bk-validation-display></bk-validation-display>
            <div class="misc-customerinfo selected-org-description">
                <span>When your page is shared on social media, this text will accompany any auto-generated "preview cards". If you don't enter anything, we'll generate this text from your answers above.</span>
            </div>
        </div>
    </div>

    <div class="margin-top padding-top padding-bottom padding-left-right twofer campaign-participant-profile-edit-visible">
        <div class="campaign-participant-profile-edit-input-holder">
            <div class="input-holder checkbox-input-holder">
                <input type="checkbox" name="CampaignParticipantVisible" [(ngModel)]="campaignParticipantMission.visible" (click)="toggleVisible(missionForm.ngForm)">
                <div class="checkbox-input-label">
                    <span class="maincolor">List my profile on the main campaign page.</span>
                </div>
            </div>
        </div>

        <div *ngIf="!campaignParticipantMission?.visible" class="campaign-participant-profile-edit-line margin-top padding-top padding-bottom padding-left-right has-hint" style="border: 2px solid #feb204; color: #700e01; background-color: rgba(0, 0, 0, 0.01);">
            <span>Your mission will not be listed on the main campaign page, but anyone with your profile URL (<a target="_blank" [href]="campaignParticipantMissionUrl()">{{campaignParticipantMissionUrl()}}</a>) will be able to see it.</span>
        </div>
    </div>

    <bk-form-server-errors></bk-form-server-errors>

    <div class="campaign-participant-profile-edit-save-button-holder">
        <app-button
            class="campaign-participant-profile-edit-button"
            [disabled]="
                saving
                ||
                !missionForm.ngForm.dirty
            "
            (click)="missionForm.submit()"
            [busy]="saving"
        >
            <span *ngIf="!saved || missionForm.ngForm.dirty">Save</span>
            <span *ngIf="saved && !missionForm.ngForm.dirty">Saved</span>
        </app-button>
    </div>
</form>

<div
    *ngIf="campaignParticipantMission.payments?.length && env.user?.is_super"
    style="padding-top: 35px;"
>
    <div style="padding-bottom: 15px;">
        <div style="font-size: 20px;">Payments ({{campaignParticipantMission.payments.length}})</div>
        <div style="padding-top: 4px; font-size: 13px;">
            <div>Absolute total amount: {{paymentAmounts.absolute | currency}} (irrespective of currency)</div>
            <div *ngFor="let pabc of paymentAmounts.byCurrency">
                <div>Total {{pabc.currencyCode}}: {{pabc.amount | currency}}</div>
            </div>
        </div>
    </div>
    <!-- <pre [innerHtml]="campaignParticipantMission.payments[0] | stirfry"></pre> -->
    <div *ngFor="let payment of campaignParticipantMission.payments" style="font-size: 13px; padding: 3px 0px;">
        <span style="display: inline-block; width: 200px; padding-right: 15px;">{{payment.created_at | friendlyDateTime}}</span>
        <span style="display: inline-block; width: 125x; padding: 0px 15px; border-left: 1px solid grey;">{{payment.amount | currency}}</span>
        <span style="display: inline-block; width: 50px; padding: 0px 15px; border-left: 1px solid grey;">{{payment.currency_code}}</span>
    </div>
</div>
